// extracted by mini-css-extract-plugin
export var formContainer = "_cp-0";
export var message = "_cp-1";